import { render, staticRenderFns } from "./SolutionsView.vue?vue&type=template&id=7844ba80&scoped=true"
import script from "./SolutionsView.vue?vue&type=script&lang=js"
export * from "./SolutionsView.vue?vue&type=script&lang=js"
import style0 from "./SolutionsView.vue?vue&type=style&index=0&id=7844ba80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844ba80",
  null
  
)

export default component.exports